var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.show),expression:"item.show"}],class:['drag', _vm.action ? 'drag-action' : ''],style:({
    zIndex: _vm.item.zIndex,
    transform: ("translate3d(" + _vm.x + "px, " + _vm.y + "px, 0)"),
    width: _vm.item.width + 'px',
    height: _vm.item.height + 'px'
  }),on:{"touchstart":_vm.onStart,"touchmove":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onMove.apply(null, arguments)},"touchend":_vm.onEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }